import { FolderTreeItem } from "../useQueryFolderTree";
import { VirtualFolders } from "@zapier/utils";
// Do a breadth-first search to find a folder in the folder tree

export function findFolderInTree(
  folderTree: FolderTreeItem[],
  folderId: string | VirtualFolders,
) {
  const queue: FolderTreeItem[] = [...folderTree];

  while (queue.length > 0) {
    const current = queue.shift();

    if (String(current?.id) === String(folderId)) {
      return current;
    }

    if (current?.children) {
      for (const child of current.children) {
        queue.push(child as FolderTreeItem);
      }
    }
  }

  return; // Return undefined if no matching folder is found
}
